const API_BASE_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'production' 
    ? '/api' 
    : 'http://localhost:5000/api'
);

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const createListing = async (images: File[], aiResponse: string): Promise<any> => {
  const formData = new FormData();
  images.forEach(image => formData.append('images', image))
  formData.append('aiResponse', aiResponse.toString())

  const response = await fetch(`${API_BASE_URL}/send-listing-to-api`, {
    method: 'POST',
    body: formData,
    headers: getAuthHeaders()
  })
  return response;
}

export type RunWorkflowOptions = {
  fileGroups?: File[][];
};

export const runWorkflow = async (
  workflowId: number,
  files: File[],
  options?: RunWorkflowOptions
): Promise<any> => {
  const formData = new FormData();
  formData.append('workflowId', workflowId.toString());

  const groups = options?.fileGroups;
  const nonEmptyGroups =
    groups && groups.length > 0
      ? groups.filter(g => Array.isArray(g) && g.length > 0)
      : [];

  if (nonEmptyGroups.length > 0) {
    nonEmptyGroups.forEach((group, i) => {
      const field = `images_${i}`;
      group.forEach(file => formData.append(field, file));
    });
    formData.append('imageGroupCount', String(nonEmptyGroups.length));
  } else {
    files.forEach(image => formData.append('images', image));
  }

  const response = await fetch(`${API_BASE_URL}/workflowOperation/run`, {
    method: 'POST',
    body: formData,
    headers: getAuthHeaders()
  });
  return response;
};

export const sendListingToAPI = async (prompt: any): Promise<any> => {
  let body = {...prompt};
  console.log(body);

  const response = await fetch(`${API_BASE_URL}/send-listing-to-api`, {
    method: 'POST',
    body,
    headers: getAuthHeaders()
  })
  return response;
}